const getUrlParam = key => {
  const url = window.location.href // 获取当前页面的 URL
  const paramStr = url.split('?')[1] // 获取 URL 中的参数部分

  if (paramStr) {
    const paramArr = paramStr.split('&') // 将参数字符串拆分成数组

    for (let i = 0; i < paramArr.length; i++) {
      const param = paramArr[i].split('=')
      // let paramName = decodeURIComponent(param[0]); // 解码参数名
      // let paramValue = decodeURIComponent(param[1]); // 解码参数值
      const paramName = param[0]
      const paramValue = param[1]
      if (paramName === key) {
        return paramValue // 如果找到匹配的参数名，返回参数值
      }
    }
  }
  return undefined
}

const addParams = function (url, paramsString) {
  if (url.indexOf('?') > -1) {
    return `${url}&${paramsString}`
  } else {
    return `${url}?${paramsString}`
  }
}

export { getUrlParam, addParams }
